import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import Home from "../views/Home/index.vue";
import SL from "../views/SL/index.vue";
import Recharge from "../views/recharge/index.vue";
import Stripe from "../views/stripe/index.vue";
import Scheme from "../views/scheme.vue";
import OumiHome from "../views/Home/oumi-home.vue";
import OumiRecharge from "../views/recharge/oumi_recharge.vue";
// import GemRecharge from "../views/recharge/gem_recharge.vue";
import JaOumiHome from "../views/Home/ja-oumi-home.vue";
import JaOumiRecharge from "../views/recharge/ja_oumi_recharge.vue";
const routes = [
  {
    path: "/",
    component: OumiHome,
  },
  {
    path: "/ja",
    component: JaOumiHome,
    meta: { hideHeader: true },
  },
  {
    path: "/ja/recharge",
    name: "ja-recharge",
    component: JaOumiRecharge,
    meta: { hideHeader: true },
  },
  {
    path: "/SL",
    component: SL,
  },
  {
    path: "/recharge",
    name: "recharge",
    // component: Recharge,
    component: OumiRecharge,
    meta: { hideHeader: true },
  },
  // {
  //   path: "/gemRecharge",
  //   name: "gemRecharge",
  //   component: GemRecharge,
  //   meta: { hideHeader: true },
  // },
  {
    path: "/stripe",
    name: "stripe",
    component: Stripe,
    meta: { hideHeader: true }
  },
  {
    path:"/scheme",
    name:"scheme",
    component:Scheme,
  }
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes: routes,
});

export default router;
